import Products from '../components/Products';

export default function AllProducts() {
  return <Products filter='all' />;
}
